import { CallAPI } from "../../apiManager/ApiCall";

const base = "payment/app-review-feedback";

const emptySummary = () => ({
  thumbs_up: 0,
  thumbs_down: 0,
  total: 0,
  by_platform: [],
});

export const GetAppReviewFeedbackCall = async ({
  limit = 50,
  offset = 0,
} = {}) => {
  try {
    const q = new URLSearchParams();
    q.set("limit", String(limit));
    q.set("offset", String(offset));
    const response = await CallAPI({
      url: `${base}?${q.toString()}`,
      method: "GET",
    });
    if (response?.success && Array.isArray(response?.data)) {
      return {
        rows: response.data,
        total:
          typeof response.total === "number"
            ? response.total
            : response.data.length,
        summary: response.summary || emptySummary(),
      };
    }
    return { rows: [], total: 0, summary: emptySummary() };
  } catch {
    return { rows: [], total: 0, summary: emptySummary() };
  }
};

export const DeleteAppReviewFeedbackCall = async (id) => {
  try {
    const response = await CallAPI({
      url: `${base}/${encodeURIComponent(id)}`,
      method: "DELETE",
    });
    return { ok: response?.success === true, response };
  } catch {
    return { ok: false, response: null };
  }
};

export const BulkDeleteAppReviewFeedbackCall = async (ids) => {
  try {
    const response = await CallAPI({
      url: `${base}/bulk-delete`,
      method: "POST",
      body: { ids },
    });
    return {
      ok: response?.success === true,
      deleted: typeof response?.deleted === "number" ? response.deleted : 0,
      response,
    };
  } catch {
    return { ok: false, deleted: 0, response: null };
  }
};
